import React, { useState } from "react";
import {
  Container,
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Typography,
  Grid,
  Button,
  Autocomplete,
} from "@mui/material";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import { Close, RemoveRedEyeOutlined } from "@mui/icons-material";
import { EditIcon } from "../comps/CustomIcons";

const EXCLUDE_LABEL = [
  {
    id: 1,
    label: "Sl. No.",
    value: "slNo",
  },
  {
    id: 2,
    label: "Item Code",
    value: "itemCode",
  },
  {
    id: 3,
    label: "Medicine Name",
    value: "medicineName",
  },
  {
    id: 4,
    label: "Current Stock",
    value: "currentStock",
  },
  {
    id: 5,
    label: "Quantity",
    value: "quantity",
  },
  {
    id: 6,
    label: "",
    value: "",
  },
];

const PharmacyOutsiderReopen = () => {
  const [excludedDepartments, setExcludedDepartments] = useState([
    {
      itemCode: "",
      medicineName: "",
      currentStock: "",
      quantity: "",
    },
  ]);

  // handle add item
  const handleAddTableRow = (currentElement, currentState, newRowData) => {
    currentState([...currentElement, newRowData]);
  };

  // handle remove item
  const handleRemoveTableRow = (rowIndex, currentElement, currentState) => {
    currentState(currentElement?.filter((_, index) => index !== rowIndex));
  };

  // Function to update input values in the state
  const handleInputChange = (event, rowIndex, currentState) => {
    const { value, name } = event.target;

    // Update state without modifying the original array
    currentState((prevState) =>
      prevState.map((row, i) =>
        i === rowIndex ? { ...row, [name]: value } : row
      )
    );
  };
  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>
        <Box sx={{ width: "100%", pr: "90px", py: "20px" }}>
          <Typography sx={{ mb: "20px" }}>Pharmacy Outsider</Typography>

          {/* Patient Information */}
          <Box
            sx={{
              backgroundColor: "rgba(240, 247, 252, 1)",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Patient Information
            </Typography>
            <Grid container spacing={2}>
              {/* contactNumber */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Autocomplete
                  options={[]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Contact Number"
                      name="contactNumber"
                      required
                      fullWidth
                      sx={{ bgcolor: "white" }}
                    />
                  )}
                />
              </Grid>
              {/* uhid */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  label="UHID"
                  name="uhid"
                  required
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>

              {/* name */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Autocomplete
                  options={[]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Name"
                      name="name"
                      required
                      fullWidth
                      sx={{ bgcolor: "white" }}
                    />
                  )}
                />
              </Grid>
              {/* doctorName */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Autocomplete
                  options={[]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Doctor Name"
                      name="doctorName"
                      required
                      fullWidth
                      sx={{ bgcolor: "white" }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Invoice Number */}
          <Typography sx={{ mb: "30px", fontWeight: 600 }}>
            Invoice Number : PHR8959885
          </Typography>

          <TableContainer component={Paper} sx={{ mb: "30px" }}>
            <Table>
              <TableHead
                sx={{
                  bgcolor: "#EAEAEA",
                }}
              >
                <TableRow>
                  {EXCLUDE_LABEL?.map((option) => (
                    <TableCell
                      key={option?.id}
                      sx={{
                        textAlign: option?.align || "left",
                        color: "#5D6A82",
                      }}
                    >
                      {option?.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {excludedDepartments?.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {EXCLUDE_LABEL?.map((column, columnIndex) => (
                      <TableCell
                        key={`${rowIndex}${columnIndex}`}
                        sx={{ color: "#5D6A82" }}
                      >
                        {columnIndex === EXCLUDE_LABEL?.length - 1 ? (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <RemoveRedEyeOutlined
                              sx={{
                                cursor: "pointer",
                                fontSize: "18px",
                              }}
                            />
                            <EditIcon
                              sx={{
                                cursor: "pointer",
                                color: "transparent",
                                fontSize: "18px",
                              }}
                            />
                            <Close
                              sx={{ cursor: "pointer", fontSize: "18px" }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  rowIndex,
                                  excludedDepartments,
                                  setExcludedDepartments
                                )
                              }
                            />
                          </Box>
                        ) : (
                          <TextField
                            label={column?.label}
                            required
                            fullWidth
                            name={column?.value}
                            // value={row[column?.value] || ""}
                            // onChange={(e) =>
                            //   handleInputChange(
                            //     e,
                            //     rowIndex,
                            //     setExcludedDepartments
                            //   )
                            // }
                          />
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    colSpan={EXCLUDE_LABEL?.length}
                    sx={{ color: "#92A6CC", cursor: "pointer" }}
                    onClick={() =>
                      handleAddTableRow(
                        excludedDepartments,
                        setExcludedDepartments,
                        {}
                      )
                    }
                  >
                    + Add item
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* save button */}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                minWidth: "150px",
                textTransform: "none",
              }}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default PharmacyOutsiderReopen;
